export const config = {
  apiUrl: process.env.REACT_APP_API_URL || "https://localhost:5001/api",
  // pathianDataApiUrl: process.env.REACT_APP_PATHIAN_DATA_API_URL || "http://localhost:7071/api",
  pathianDataApiUrl: process.env.REACT_APP_PATHIAN_DATA_API_URL || "https://pathian-data-api.azure-api.net/api/v1",
};
